import React, { useState, useEffect, useRef } from "react";

import {
  //List group
  CListGroup,
  CListGroupItem,
  //Table
  CTable,
  CTableRow,
  CTableBody,
  CTableDataCell,
  CTableHeaderCell,
  //Pagination
  CPagination,
  CPaginationItem
} from "@coreui/react";

//components
import LoadingCenter from "../components/LoadingCenter";
import ViewHeader from "../components/Template/ViewHeader";
import THead from "../components/AccessReports/Table/THead";
import TDataAuction from "../components/AccessReports/Table/TDataAuction";

import useAxiosFunction from "../hooks/useAxiosFunction";
import axiosInstance from "../apis/gvmdesk";
import useLocalStorage from "use-local-storage";

const AccessReports = (props) => {
  const [theme] = useLocalStorage("theme");
  const [previous, setPrevious] = React.useState(true);
  const [next, setNext] = React.useState(false);

  const numberPage = useRef(1);
  const [qtdPag, setQtdPag] = useState("");

  const [accessReports, setAccessReports, loading, error, axiosFetch] = useAxiosFunction();

  React.useEffect(() => {
    axiosFetch({
      axiosInstance,
      method: "GET",
      url: "/users/relatorio/acesso?page=" + numberPage.current,
      redirect_to: "",
      data: {}
    });

    setQtdPag(accessReports?.qtd);

  }, []);

  const previousPage = (page) => {

    numberPage.current = page - 1;
    if (numberPage.current == 1) {
      setPrevious(true);
    }

    axiosFetch({
      axiosInstance,
      method: "GET",
      url: "/users/relatorio/acesso?page=" + numberPage.current,
      redirect_to: "",
      data: {}
    });

    setNext(true);
  }

  const proxPage = (page) => {

    numberPage.current = page + 1;
    setPrevious(false);

    if (numberPage.current == qtdPag) {
      setNext(true);
    }

    axiosFetch({
      axiosInstance,
      method: "GET",
      url: "/users/relatorio/acesso?page=" + numberPage.current,
      redirect_to: "",
      data: {}
    });

  }

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <span>Relatório de acessos</span>
      </div>

      <div className="dashboard__container">
        {loading && <LoadingCenter />}
        {!loading && <CTable color={theme} hover>
          <THead />
          <CTableBody>
            {accessReports && !loading && accessReports.map(report => {
              return (
                <CTableRow key={report.id}>
                  <CTableHeaderCell>{report.name}</CTableHeaderCell>
                  <CTableDataCell>{report.date}</CTableDataCell>

                  <CTableDataCell>
                    <CListGroup>
                      {report.success_auctions?.length <= 0 && "SEM ACESSO RECENTE"}
                      {report.success_auctions?.map(auction => {
                        return (
                          <CListGroupItem key={auction.id}>{auction.title}</CListGroupItem>
                        );
                      })}
                    </CListGroup>
                  </CTableDataCell>

                  <TDataAuction data={report.products} />
                </CTableRow>
              );
            })}
          </CTableBody>
        </CTable>}

        <CPagination align="center" aria-label="Navegação da tabela de clientes" className="m-t-20">
          <CPaginationItem disabled={previous} onClick={() => previousPage(numberPage.current)}>Anterior</CPaginationItem>
          <CPaginationItem disabled={next} onClick={() => proxPage(numberPage.current)} >Próximo</CPaginationItem>
        </CPagination>
      </div>
    </div>
  );
};

AccessReports.defaultProps = {};

export default AccessReports;